import useSWR, { Fetcher } from "swr";

type ItemInventory = {
  available: number;
  purchased: number;
  price: number;
};

type ItemInventorySet = Record<string, ItemInventory>;

const fetcher: Fetcher<ItemInventorySet, string> = (url: string) =>
  fetch(url).then((res) => res.json() as Promise<ItemInventorySet>);

export function useInventory(workId: number, refreshInterval: number = 30000) {
  const { data: inventorySet } = useSWR(
    `https://vg36n7rbsk7wlwrr2enzr75fpe0nwfth.lambda-url.ap-southeast-2.on.aws/inventory/${workId}`,
    fetcher,
    {
      refreshInterval,
    }
  );
  return inventorySet;
}
